import { IMultiSelectSettings, IMultiSelectTexts } from "ngx-bootstrap-multiselect";

export function getMultiSelectSettings(overrideSettings: IMultiSelectSettings=null): IMultiSelectSettings {
  let settings: IMultiSelectSettings= {
    enableSearch: true,
    displayAllSelectedText: true,
    dynamicTitleMaxItems: 3,
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'form-control dropdown-toggle',
    containerClasses: 'ss-multiselect-dropdown',
  };
  if (overrideSettings) {
    Object.assign(settings, overrideSettings);
  }
  return settings;
}
export function getMultiSelectTexts(overrideSettings: IMultiSelectTexts=null): IMultiSelectTexts {
  let settings: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Deselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Search',
    defaultTitle: '',
    allSelected: 'All selected'
  };
  if (overrideSettings) {
    Object.assign(settings, overrideSettings);
  }
  return settings;
}
